export const EXTRA_ROWS_TO_VIRTUALISE = 10;
export const ROWS_HEIGHT = 50;
export const ALL_ACCOUNTS_DEFAULT = '__ALL_ACCOUNTS_DEFAULT__';
